import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchInspectionKindDetail(id) {
  const { data: raw } = await request.get(`/ims/inspection-kinds/${id}`);
  return parseVer4DetailResponse(raw);
}
